import { localeLastWinsType } from '../en-US'

export const lastWins: localeLastWinsType = {
  casinoBets: 'Apuestas de Casino',
  game: 'Juego',
  provider: 'Proveedor',
  username: 'Nombre de usuario',
  player: 'Jugador',
  time: 'Tiempo',
  timeToWin: 'Es hora de ganar',
  betAmount: 'Monto de la apuesta',
  multiplier: 'Multiplicador',
  winAmount: 'Cantidad ganada',
  privateOn: 'Modo privado activado',
  privateOff: 'Modo privado desactivado',
  stealth: 'Sigilo',
  privacyEnabledTooltip: 'Este usuario tiene la privacidad activada',

  tableTypes: {
    standard: 'Todas las apuestas',
    high_rollers: 'Grandes apostadores',
    lucky_bets: 'Apuestas afortunadas',
  },
}
